var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25839_117016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.34375 8.74862C7.61108 8.51099 8.01392 8.51099 8.28125 8.74862C8.46287 8.91004 8.75 8.78112 8.75 8.53812V1.45903C8.75 1.21602 8.46287 1.08708 8.28125 1.24853C8.01392 1.48616 7.61108 1.48616 7.34375 1.24853C7.07642 1.01091 6.67358 1.01091 6.40625 1.24853C6.13892 1.48616 5.73608 1.48616 5.46875 1.24853C5.20142 1.01091 4.79858 1.01091 4.53125 1.24853C4.26392 1.48616 3.86108 1.48616 3.59375 1.24853C3.32642 1.01091 2.92358 1.01091 2.65625 1.24853C2.38892 1.48616 1.98608 1.48616 1.71875 1.24853C1.53712 1.08708 1.25 1.21602 1.25 1.45903V8.53812C1.25 8.78112 1.53712 8.91004 1.71875 8.74862C1.98608 8.51099 2.38892 8.51099 2.65625 8.74862C2.92358 8.98624 3.32642 8.98624 3.59375 8.74862C3.86108 8.51099 4.26392 8.51099 4.53125 8.74862C4.79858 8.98624 5.20142 8.98624 5.46875 8.74862C5.73608 8.51099 6.13892 8.51099 6.40625 8.74862C6.67358 8.98624 7.07642 8.98624 7.34375 8.74862Z",
    stroke: "#5078C8",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.46094H6.875",
    stroke: "#5078C8",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5H6.875",
    stroke: "#5078C8",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 3.53906H6.875",
    stroke: "#5078C8",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25839_117016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBillIcon);
export default __webpack_public_path__ + "static/media/blue_bill_Icon.0b6211f279b2139511f7e0943745b998.svg";
export { ForwardRef as ReactComponent };